import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20flowing%20digital%20patterns%20and%20geometric%20shapes%2C%20deep%20navy%20blue%20and%20white%20color%20scheme%2C%20minimalist%20professional%20design%2C%20soft%20gradients%2C%20clean%20contemporary%20aesthetic%2C%20high%20tech%20atmosphere%2C%20sophisticated%20business%20technology%20visualization&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Debug software development company hero background"
          title="Debug - Expert Software Debugging & Development Solutions"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
          <span className="text-white text-sm font-semibold">{t('heroTag')}</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          {t('heroTitle1')}<br />
          <span className="text-[rgb(0,0,139)] bg-white px-4 py-2 inline-block mt-2">{t('heroTitle2')}</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
          {t('heroDescription')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-[rgb(0,0,139)] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[rgb(0,0,100)] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            {t('startProject')}
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all border border-white/30 cursor-pointer whitespace-nowrap"
          >
            {t('exploreServices')}
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button 
          onClick={() => scrollToSection('services')}
          className="animate-bounce cursor-pointer"
          aria-label="Scroll to services section"
        >
          <i className="ri-arrow-down-line text-4xl text-white"></i>
        </button>
      </div>
    </section>
  );
}